module.exports = __webpack_public_path__ + "img/progressHub.cf6f2201.svg";